import style from './Divider.module.css';

export default function Divider(props: { className?: string }) {
  const { className } = props;
  return <div className={[style.container, className].join(' ')} />;
}
